import React from 'react';
import { useTranslation } from 'react-i18next';
import { MessageSquare, Wand2, Download } from 'lucide-react';

const HowItWorks = () => {
  const { t } = useTranslation();
  const steps = [
    { icon: MessageSquare, titleKey: 'howItWorks.step1Title', descKey: 'howItWorks.step1Desc', accent: 'from-pink-400 to-rose-300', bg: 'bg-pink-50' },
    { icon: Wand2, titleKey: 'howItWorks.step2Title', descKey: 'howItWorks.step2Desc', accent: 'from-purple-400 to-violet-300', bg: 'bg-purple-50' },
    { icon: Download, titleKey: 'howItWorks.step3Title', descKey: 'howItWorks.step3Desc', accent: 'from-amber-400 to-yellow-300', bg: 'bg-amber-50' },
  ];

  return (
    <div className="py-24 px-4 bg-white/80" data-testid="how-it-works">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-center text-gray-800 mb-3">{t('howItWorks.title')}</h2>
        <p className="text-center text-gray-500 mb-16 text-base">{t('howItWorks.subtitle')}</p>
        <div className="grid md:grid-cols-3 gap-8 stagger-children">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="card-hover bg-white rounded-2xl p-8 text-center shadow-sm relative fade-in" data-testid={`step-${index + 1}`}>
                <div className={`absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r ${step.accent} text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold shadow-md`}>{index + 1}</div>
                <div className={`${step.bg} w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6 mt-2`}><Icon className="w-7 h-7 text-gray-700" /></div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">{t(step.titleKey)}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{t(step.descKey)}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default HowItWorks;
